import React from "react";
import { Box, Stack, Tooltip, Typography } from "@mui/material";

function StockCountCrossDetailSummary({ rows = [], item, formatQty }) {
  if (!rows.length) return "-";
  const label = rows[0]?.direction === "IN" ? "Recibe" : "Entrega";
  const tooltipTitle = (
    <Stack spacing={0.6}>
      <Typography variant="caption" sx={{ fontWeight: 800 }}>
        Orden del cruce
      </Typography>
      {rows.map((row, index) => (
        <Box key={`${row.direction}-${row.relatedProduct}-${row.cross?.id || index}`}>
          <Typography variant="caption" display="block" sx={{ fontWeight: 800 }}>
            {index + 1}. {row.relatedProduct}
          </Typography>
          <Typography variant="caption" display="block">
            {formatQty(row, item)}
          </Typography>
        </Box>
      ))}
    </Stack>
  );

  return (
    <Tooltip title={tooltipTitle} arrow>
      <Stack spacing={0.25} sx={{ minWidth: 0, py: 0.4 }}>
        <Typography variant="caption" sx={{ fontWeight: 800, color: rows[0]?.color ? `${rows[0].color}.main` : "text.primary" }}>
          {label}
        </Typography>
        {rows.slice(0, 3).map((row, index) => (
          <Stack
            key={`${row.direction}-${row.relatedProduct}-${row.cross?.id || index}`}
            direction="row"
            spacing={0.7}
            alignItems="center"
            sx={{ minWidth: 0 }}
          >
            <Typography variant="caption" noWrap sx={{ minWidth: 0, flex: 1 }}>
              {row.relatedProduct}
            </Typography>
            <Typography variant="caption" sx={{ fontWeight: 800, whiteSpace: "nowrap" }}>
              {formatQty(row, item)}
            </Typography>
          </Stack>
        ))}
        {rows.length > 3 ? (
          <Typography variant="caption" color="text.secondary">
            +{rows.length - 3} cruces
          </Typography>
        ) : null}
      </Stack>
    </Tooltip>
  );
}

export default StockCountCrossDetailSummary;
